/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './lab-hospital-association.reducer';

export const LabHospitalAssociation = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const labHospitalAssociationList = useAppSelector(state => state.labHospitalAssociation.entities);
  const loading = useAppSelector(state => state.labHospitalAssociation.loading);
  const totalItems = useAppSelector(state => state.labHospitalAssociation.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="lab-hospital-association-heading" data-cy="LabHospitalAssociationHeading">
        <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.home.title">Lab Hospital Associations</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/lab-hospital-association/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.home.createLabel">Create new Lab Hospital Association</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.labHospitalAssociation.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {labHospitalAssociationList && labHospitalAssociationList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('associatedDate')}>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.associatedDate">Associated Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('associatedDate')} />
                </th>
                <th className="hand" onClick={sort('leavingDate')}>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.leavingDate">Leaving Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('leavingDate')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('openingTime')}>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.openingTime">Opening Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('openingTime')} />
                </th>
                <th className="hand" onClick={sort('closeTime')}>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.closeTime">Close Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('closeTime')} />
                </th>
                <th className="hand" onClick={sort('internal')}>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.internal">Internal</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('internal')} />
                </th>
                <th className="hand" onClick={sort('createdDtm')}>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.createdDtm">Created Dtm</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdDtm')} />
                </th>
                <th className="hand" onClick={sort('createdBy')}>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.createdBy">Created By</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdBy')} />
                </th>
                <th className="hand" onClick={sort('modifiedBy')}>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.modifiedBy">Modified By</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedBy')} />
                </th>
                <th className="hand" onClick={sort('leftAssociation')}>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.leftAssociation">Left Association</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('leftAssociation')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.diagLab">Diag Lab</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.hospital">Hospital</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {labHospitalAssociationList.map((labHospitalAssociation, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/lab-hospital-association/${labHospitalAssociation.id}`} color="link" size="sm">
                      {labHospitalAssociation.id}
                    </Button>
                  </td>
                  <td>{labHospitalAssociation.associatedDate}</td>
                  <td>{labHospitalAssociation.leavingDate}</td>
                  <td>{labHospitalAssociation.timestampentry}</td>
                  <td>{labHospitalAssociation.microSec}</td>
                  <td>{labHospitalAssociation.lastupdated}</td>
                  <td>{labHospitalAssociation.active ? 'true' : 'false'}</td>
                  <td>{labHospitalAssociation.cursor}</td>
                  <td>{labHospitalAssociation.openingTime}</td>
                  <td>{labHospitalAssociation.closeTime}</td>
                  <td>{labHospitalAssociation.internal ? 'true' : 'false'}</td>
                  <td>{labHospitalAssociation.createdDtm}</td>
                  <td>{labHospitalAssociation.createdBy}</td>
                  <td>{labHospitalAssociation.modifiedBy}</td>
                  <td>{labHospitalAssociation.leftAssociation ? 'true' : 'false'}</td>
                  <td>
                    {labHospitalAssociation.diagLab ? (
                      <Link to={`/diag-lab/${labHospitalAssociation.diagLab.id}`}>{labHospitalAssociation.diagLab.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {labHospitalAssociation.hospital ? (
                      <Link to={`/hospital/${labHospitalAssociation.hospital.id}`}>{labHospitalAssociation.hospital.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/lab-hospital-association/${labHospitalAssociation.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/lab-hospital-association/${labHospitalAssociation.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/lab-hospital-association/${labHospitalAssociation.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.home.notFound">No Lab Hospital Associations found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={labHospitalAssociationList && labHospitalAssociationList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default LabHospitalAssociation;
